<template>
  <div>
    <list-template
      :current-page="page"
      :loading="loading"
      :search-config="searchConfig"
      :table-config="tableConfig"
      :table-data="tableData"
      :total="total"
      has-add
      @onAdd="openCreate"
      @onChangePage="changeCurrentPage"
      @onHandle="tableHandle"
      @onReset="onReset"
      @onSearch="onSearch"
    />

    <el-dialog :title="editing ? '编辑菜单' : '新增菜单'" :visible.sync="dialogVisible" custom-class="menu-dialog" width="840px" @closed="resetForm">
      <el-form ref="menuForm" class="menu-form" :model="menuForm" :rules="rules" label-width="100px">
        <el-form-item label="所属校区" prop="school_id">
          <el-select v-model="menuForm.school_id" filterable placeholder="请选择校区" style="width: 100%">
            <el-option v-for="school in schoolOptions" :key="school.id" :label="school.school_name" :value="school.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="菜单名称" prop="name">
          <el-input v-model="menuForm.name" maxlength="50" placeholder="请输入菜单名称" />
        </el-form-item>
        <el-form-item class="menu-items-form-item" label="菜单项">
          <div v-for="(item, index) in menuForm.menu_json" :key="index" class="menu-item-row">
            <div class="menu-item-header">
              <span class="menu-item-index">菜单项 {{ index + 1 }}</span>
              <el-button class="menu-item-delete" type="text" @click="removeMenuItem(index)">
                <i class="el-icon-delete" /> 删除
              </el-button>
            </div>
            <div class="menu-item-content">
              <div class="menu-field menu-name-field">
                <span class="menu-field-label">菜品名称</span>
                <el-input v-model="item.name" maxlength="100" placeholder="请输入菜品名称" />
              </div>
              <div class="menu-image-section">
                <span class="menu-field-label">菜品图片</span>
                <el-upload
                  class="menu-image-uploader"
                  :action="$_axios2.defaults.baseURL + '/api/upload/upload'"
                  :data="{ site_size: 20 }"
                  :headers="{ authorization: 'Bearer ' + $store.getters.token }"
                  :multiple="false"
                  :show-file-list="false"
                  accept="image/*"
                  name="upload"
                  :before-upload="beforeImageUpload"
                  :on-success="(response, file) => onImageUploadSuccess(response, file, item)"
                  :on-error="onImageUploadError"
                >
                  <div v-if="item.pic" class="menu-image-tile menu-image-filled">
                    <div class="menu-image-preview-hitbox" @click.stop>
                      <el-image
                        :src="item.pic"
                        :preview-src-list="previewImages"
                        fit="cover"
                        class="menu-image-preview"
                      >
                        <div slot="error" class="menu-image-state">
                          <i class="el-icon-picture-outline" />
                          <span>图片加载失败</span>
                        </div>
                      </el-image>
                    </div>
                    <div class="menu-image-replace"><i class="el-icon-refresh" /> 点击更换</div>
                  </div>
                  <div v-else class="menu-image-tile menu-image-empty">
                    <i class="el-icon-plus" />
                    <span>点击上传图片</span>
                  </div>
                </el-upload>
              </div>
            </div>
          </div>
          <el-button class="add-menu-item" icon="el-icon-plus" plain size="small" @click="addMenuItem">添加菜单项</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submitForm">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  _config: { route: { path: 'list', meta: { title: '列表', keepAlive: true } } },
  data() {
    return {
      loading: false,
      saving: false,
      dialogVisible: false,
      editing: false,
      total: 0,
      tableData: [],
      schoolOptions: [],
      search: {},
      menuForm: this.emptyForm(),
      rules: {
        school_id: [{ required: true, message: '请选择所属校区', trigger: 'change' }],
        name: [{ required: true, message: '请输入菜单名称', trigger: 'blur' }]
      },
      searchConfig: [
        { prop: 'school_id', tag: 'select', placeholder: '筛选校区', options: [], label: 'school_name', value: 'id' },
        { prop: 'name', placeholder: '搜索菜单名称' }
      ],
      tableConfig: [
        { prop: 'id', label: 'ID', width: 90 },
        { prop: 'school_name', label: '所属校区', width: 160 },
        { prop: 'name', label: '菜单名称', width: 160 },
        { prop: 'menu_summary', label: '菜单内容', minWidth: 240 },
        { prop: 'creator', label: '创建人', width: 120 },
        { prop: 'created_at', label: '创建时间', width: 170 },
        { prop: 'updated_at', label: '更新时间', width: 170 },
        { label: '操作', width: 100, render: () => [{ type: 'edit', text: '编辑' }] }
      ]
    }
  },
  computed: {
    ...mapState(['page']),
    previewImages() {
      return this.menuForm.menu_json.map(item => item.pic).filter(Boolean)
    }
  },
  created() {
    this.loadSchools()
  },
  mounted() {
    this.$store.commit('setPage', 1)
    this.getData()
  },
  activated() {
    this.getData()
  },
  methods: {
    emptyForm() {
      return { id: null, school_id: '', name: '', menu_json: [] }
    },
    loadSchools() {
      this.$_axios2.get('/api/common/base-school', { params: { usage: 3 } }).then(res => {
        const schools = (res.data.data && res.data.data.school) || []
        this.schoolOptions = schools
        this.searchConfig[0].options = schools
      })
    },
    getData() {
      this.loading = true
      this.$_axios2.get('/api/canteen-menu/index', {
        params: { page: this.page, ...this.search }
      }).then(res => {
        const data = res.data.data || {}
        this.tableData = (data.list || []).map(item => ({
          ...item,
          menu_summary: (item.menu_json || []).map(menuItem => menuItem.name || menuItem.pic || '').filter(Boolean).join('、') || '-'
        }))
        this.total = (data.page && data.page.total) || 0
      }).finally(() => { this.loading = false })
    },
    changeCurrentPage(value) {
      this.$store.commit('setPage', value)
      this.getData()
    },
    onSearch(value) {
      this.search = value || {}
      this.$store.commit('setPage', 1)
      this.getData()
    },
    onReset() {
      this.search = {}
      this.$store.commit('setPage', 1)
      this.getData()
    },
    openCreate() {
      this.editing = false
      this.menuForm = this.emptyForm()
      this.menuForm.menu_json.push({ name: '', pic: '' })
      this.dialogVisible = true
    },
    tableHandle(row, handle) {
      if (handle.type !== 'edit') return
      this.editing = true
      this.menuForm = {
        id: row.id,
        school_id: row.school_id,
        name: row.name,
        menu_json: (row.menu_json || []).map(item => ({ name: item.name || '', pic: item.pic || '' }))
      }
      this.dialogVisible = true
    },
    addMenuItem() {
      this.menuForm.menu_json.push({ name: '', pic: '' })
    },
    removeMenuItem(index) {
      this.menuForm.menu_json.splice(index, 1)
    },
    beforeImageUpload(file) {
      if (!file.type || !file.type.startsWith('image/')) {
        this.$message.error('请上传图片文件')
        return false
      }
      if (file.size > 20 * 1024 * 1024) {
        this.$message.error('图片大小不能超过20MB')
        return false
      }
      return true
    },
    onImageUploadSuccess(response, file, item) {
      if (response && response.status === 0 && response.data && response.data.file_addr) {
        this.$set(item, 'pic', response.data.file_addr)
        this.$message.success('图片上传成功')
      } else {
        this.$message.error((response && response.msg) || '图片上传失败')
      }
    },
    onImageUploadError() {
      this.$message.error('图片上传失败，请重试')
    },
    resetForm() {
      this.menuForm = this.emptyForm()
      this.editing = false
      if (this.$refs.menuForm) this.$refs.menuForm.clearValidate()
    },
    submitForm() {
      this.$refs.menuForm.validate(valid => {
        if (!valid) return
        const menuItems = this.menuForm.menu_json
          .map(item => ({ name: item.name.trim(), pic: item.pic.trim() }))
          .filter(item => item.name || item.pic)
        if (!menuItems.length || menuItems.some(item => !item.name && !item.pic)) {
          this.$message.warning('每个菜单项至少填写菜品名称或图片地址')
          return
        }
        const payload = {
          name: this.menuForm.name.trim(),
          school_id: this.menuForm.school_id,
          menu_json: menuItems
        }
        const url = this.editing ? '/api/canteen-menu/edit' : '/api/canteen-menu/create'
        if (this.editing) payload.id = this.menuForm.id
        this.saving = true
        this.$_axios2.post(url, payload).then(res => {
          if (res.data.status === 0) {
            this.$message.success(this.editing ? '编辑成功' : '新增成功')
            this.dialogVisible = false
            this.getData()
          }
        }).finally(() => { this.saving = false })
      })
    }
  }
}
</script>

<style scoped>
::v-deep .el-dialog.menu-dialog {
  width: 840px !important;
  max-width: calc(100vw - 32px) !important;
  border-radius: 12px !important;
}

::v-deep .el-dialog.menu-dialog .el-dialog__body {
  padding: 16px 24px 8px !important;
}

::v-deep .el-dialog.menu-dialog .t_title_body {
  padding: 0 !important;
}

::v-deep .el-dialog.menu-dialog .t_title_footer {
  margin-top: 0 !important;
}

.menu-form ::v-deep .menu-items-form-item {
  margin-bottom: 0 !important;
}

.menu-item-row {
  padding: 14px;
  margin-bottom: 12px;
  border: 1px solid #e7eaf1;
  border-radius: 9px;
  background: #fbfcfe;
  transition: border-color 0.2s, background-color 0.2s;
}

.menu-item-row:hover {
  border-color: #cbd4ff;
  background: #fafbff;
}

.menu-item-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.menu-item-index {
  color: #47516b;
  font-size: 13px;
  font-weight: 600;
}

.menu-item-content {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 12px;
}

.menu-field {
  min-width: 0;
}

.menu-name-field {
  width: 230px;
  max-width: 100%;
}

.menu-field-label {
  display: block;
  margin-bottom: 6px;
  color: #687189;
  font-size: 12px;
  line-height: 18px;
}

.menu-field ::v-deep .el-input__inner {
  height: 36px;
  line-height: 36px;
}

.menu-field ::v-deep .el-input {
  width: 100% !important;
  max-width: 100%;
}

.menu-image-section {
  width: 230px;
  max-width: 100%;
  min-width: 0;
}

.menu-image-uploader,
.menu-image-uploader ::v-deep .el-upload {
  display: block;
  width: 100%;
}

.menu-item-delete {
  padding: 6px 0;
  color: #e45b5b;
}

.menu-item-delete:hover {
  color: #c93d3d;
}

.menu-image-tile {
  position: relative;
  display: flex;
  box-sizing: border-box;
  width: 100%;
  height: 84px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 1px solid #d8deeb;
  border-radius: 7px;
}

.menu-image-empty {
  flex-direction: column;
  gap: 5px;
  border-style: dashed;
  background: #fafbfe;
  color: #7e879c;
  font-size: 12px;
}

.menu-image-empty:hover {
  border-color: #4058e8;
  background: #f5f7ff;
  color: #4058e8;
}

.menu-image-empty i {
  font-size: 20px;
}

.menu-image-preview-hitbox,
.menu-image-preview {
  display: block;
  width: 100%;
  height: 100%;
}

.menu-image-preview-hitbox {
  cursor: zoom-in;
}

.menu-image-replace {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  height: 24px;
  align-items: center;
  justify-content: center;
  gap: 4px;
  background: rgba(28, 36, 59, 0.62);
  color: #fff;
  font-size: 11px;
}

.menu-image-state {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  background: #f0f2f7;
  color: #9aa1b2;
  font-size: 11px;
}

.menu-image-state i {
  font-size: 20px;
}

.add-menu-item {
  border-style: dashed;
  color: #334bdb;
}

@media (max-width: 780px) {
  ::v-deep .el-dialog.menu-dialog {
    width: calc(100vw - 32px) !important;
  }

  ::v-deep .el-dialog.menu-dialog .el-dialog__body {
    padding: 12px 16px 4px !important;
  }

  .menu-item-row {
    padding: 12px;
  }

  .menu-item-content {
    gap: 10px;
  }

  .menu-image-tile {
    height: 80px;
  }
}

@media (max-width: 480px) {
  .menu-item-content {
    grid-template-columns: minmax(0, 1fr);
  }

  .menu-image-uploader {
    max-width: 240px;
  }
}
</style>
